'use strict'

import MockAdapter from 'axios-mock-adapter'

import accessLogRepositoryMock from './accessLogRepositoryMock'
import adminRepositoryMock from './adminRepositoryMock'
import agentRepositoryMock from './agentRepositoryMock'
import announcementRepositoryMock from './announcementRepositoryMock'
import attachmentRepositoryMock from './attachmentRepositoryMock'
import attachsizeSettingRepositoryMock from './attachsizeSettingRepositoryMock'
import authRepositoryMock from './authRepositoryMock'
import bcardImageRepositoryMock from './bcardImageRepositoryMock'
import bcardRepositoryMock from './bcardRepositoryMock'
import displaySettingRepositoryMock from './displaySettingRepositoryMock'
import exchangeRepositoryMock from './exchangeRepositoryMock'
import exlocationRepositoryMock from './exlocationRepositoryMock'
import expireSettingRepositoryMock from './expireSettingRepositoryMock'
import extriggerRepositoryMock from './extriggerRepositoryMock'
import favoriteRepositoryMock from './favoriteRepositoryMock'
import imageRepositoryMock from './imageRepositoryMock'
import infoRepositoryMock from './infoRepositoryMock'
import informationSettingsRepositoryMock from './informationSettingsRepositoryMock'
import inputProxySettingsRepositoryMock from './inputProxySettingsRepositoryMock'
import licenseSettingRepositoryMock from './licenseSettingRepositoryMock'
import mbLoginSettingRepositoryMock from './mbLoginSettingRepositoryMock'
import mergePersonsRepositoryMock from './mergePersonsRepositoryMock'
import managementBcardRepositoryMock from './managementBcardRepositoryMock'
import managementPersonRepositoryMock from './managementPersonRepositoryMock'
import mobileSettingRepositoryMock from './mobileSettingRepositoryMock'
import nisfaIntegrationRepositoryMock from './nisfaIntegrationRepositoryMock'
import passwordPolicyRepositoryMock from './passwordPolicyRepositoryMock'
import personRepositoryMock from './personRepositoryMock'
import profileSettingRepositoryMock from './profileSettingRepositoryMock'
import pvNisfaIntegrationRepositoryMock from './pvNisfaIntegrationRepositoryMock'
import pvPinRepositoryMock from './pvPinRepositoryMock'
import pvtagRepositoryMock from './pvtagRepositoryMock'
import tagRepositoryMock from './tagRepositoryMock'
import topRepositoryMock from './topRepositoryMock'
import userRepositoryMock from './userRepositoryMock'

const mockRepositories = {
  AccessLogRepository: accessLogRepositoryMock,
  AnnouncementRepository: announcementRepositoryMock,
  AdminRepository: adminRepositoryMock,
  AgentRepository: agentRepositoryMock,
  AttachmentRepository: attachmentRepositoryMock,
  AttachsizeSettingRepository: attachsizeSettingRepositoryMock,
  AuthRepository: authRepositoryMock,
  BcardImageRepository: bcardImageRepositoryMock,
  BcardRepository: bcardRepositoryMock,
  DisplaySettingRepository: displaySettingRepositoryMock,
  ExchangeRepository: exchangeRepositoryMock,
  ExlocationRepository: exlocationRepositoryMock,
  ExpireSettingRepository: expireSettingRepositoryMock,
  ExtriggerRepository: extriggerRepositoryMock,
  FavoriteRepository: favoriteRepositoryMock,
  ImageRepository: imageRepositoryMock,
  InfoRepository: infoRepositoryMock,
  InformationSettingsRepository: informationSettingsRepositoryMock,
  InputProxySettingsRepository: inputProxySettingsRepositoryMock,
  LicenseSettingRepository: licenseSettingRepositoryMock,
  MbLoginSettingRepository: mbLoginSettingRepositoryMock,
  MergePersonsRepositoryMock: mergePersonsRepositoryMock,
  ManagementBcardRepositoryMock: managementBcardRepositoryMock,
  ManagementPersonRepositoryMock: managementPersonRepositoryMock,
  MobileSettingRepository: mobileSettingRepositoryMock,
  NisfaIntegrationRepository: nisfaIntegrationRepositoryMock,
  PasswordPolicyRepository: passwordPolicyRepositoryMock,
  PersonRepository: personRepositoryMock,
  ProfileSettingRepository: profileSettingRepositoryMock,
  PvNisfaIntegrationRepository: pvNisfaIntegrationRepositoryMock,
  PvPinRepository: pvPinRepositoryMock,
  PvtagRepository: pvtagRepositoryMock,
  TagRepository: tagRepositoryMock,
  TopRepository: topRepositoryMock,
  UserRepository: userRepositoryMock
}

export default {
  init (axios) {
    let mockAxios = new MockAdapter(axios, { delayResponse: 1000 })

    Object.keys(mockRepositories).forEach(klassName => {
      mockRepositories[klassName](mockAxios) // eslint-disable-line no-new
    })
  }
}



// WEBPACK FOOTER //
// ./src/repositories/mock/index.js